import React, { useState, useEffect } from "react";
import { MapControlled } from "./MapControlled";

import { mapRequest } from "./Api";
import { Modal } from "../Modal";
import { MapConfig, MapData } from "./types";
import { Loading } from "./loading";
import { render } from "react-dom";
import { mapConfig } from "../../data/map";

const find = async <T extends Element>(path: string): Promise<T> => {
  return new Promise((resolve) => {
    const waitRender = setInterval(() => {
      const element = document.querySelector<T>(path);

      if (element) {
        clearInterval(waitRender);
        resolve(element);
      }
    }, 500);
  });
};

export const swiperFix = async () => {
  await find<HTMLCanvasElement>("#static-map canvas");
  const swiperCloneSlide = await find<Element>(
    ".swiper-slide:last-child .swiper-lazy"
  );

  render(<CarouselMap idPrefix="clone" config={mapConfig} />, swiperCloneSlide);
};

export const CarouselMap = ({
  config: { maps, title, selected: selectedCarouselMap, updateTime },
  idPrefix,
}: {
  idPrefix?: string;
  config: {
    maps: MapConfig[];
    title: string;
    selected: MapConfig;
    updateTime: string;
  };
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const delayedLoading = () => setTimeout(() => setLoading(true), 500);

  const [selectedMap, setSelectedMap] =
    useState<MapConfig>(selectedCarouselMap);

  const [data, setData] = useState<MapData>({});
  useEffect(() => {
    async function fetchData() {
      if (!data[selectedMap]) {
        const loadingTimerId = delayedLoading();
        const response = await mapRequest(selectedMap);
        clearTimeout(loadingTimerId);
        setLoading(false);

        setData({
          ...data,
          ...response,
        });
      }
    }

    fetchData();
  }, [data, selectedMap]);

  const handleChange = (option: MapConfig) => setSelectedMap(option);
  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);
  const selectedData = data ? data[selectedMap] : null;
  const staticData = data ? data[selectedCarouselMap] : null;

  return (
    <>
      <MapControlled
        maps={maps}
        selectedMap={selectedCarouselMap}
        data={staticData}
        onChange={handleChange}
        onClick={openModal}
        idPrefix={idPrefix}
        isStatic
      />
      <Modal open={open} onClose={closeModal}>
        <Modal.Header>
          <h1>{title}</h1>
          <p>{updateTime}</p>
        </Modal.Header>
        <Modal.Body>
          {loading && <Loading />}
          <MapControlled
            maps={maps}
            selectedMap={selectedMap}
            data={selectedData}
            onChange={handleChange}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
